export const STORAGE_KEY_PREFIX = "exam-session:";
export const MMKV_STORAGE_ID = "exam-session-storage";
